export default __webpack_public_path__ + "smo-blue.0d981a494a58e3b6cc1b756f3c36f562.svg";